import bannerImage from "../../assets/images/category-banners/phone-cases.png";

export default {
  h1Text: `Чехлы для телефона с твоим рисунком`,
  h2Text: ``,
  regularTextHtml: `
    <div>
      Прямая цифровая печать на чехлах для телефона
      <p>Чтобы оформить заказ, выберите понравившуюся модель, дополните дизайн своей надписью или изображением.</p>
      <p>С помощью нашего редактора вы сможете добавить любую надпись, рисунок из нашей библиотеки или загрузить изображение с компьютера. После того, как вы оформите макет, нажмите кнопку «В корзину» для завершения покупки.</p>
    </div>`,
  buttonText: `Выбрать предмет`,
  image: [bannerImage]
};
